import { FC } from 'react'
import { ImageProps } from 'next/image'

import { LinkProps } from '../Link'
import { Icons } from '../Icon'

import * as SC from './styled'

export type RetailerCardProps = {
  className?: string
  image?: ImageProps
  category?: string
  retailerWebSiteLink?: LinkProps
  description?: string
  numberOffers?: string
  minPrice?: string
  otherOffersLink?: LinkProps
}

const RetailerCard: FC<RetailerCardProps> = (props) => {
  const {
    className,
    image,
    category,
    retailerWebSiteLink,
    description,
    numberOffers,
    minPrice,
    otherOffersLink,
  } = props

  return (
    <SC.RetailerCard className={className} {...otherOffersLink}>
      {image && <SC.RetailerCardImage {...image} />}
      {category && (
        <SC.RetailerCardCategory>{category}</SC.RetailerCardCategory>
      )}
      {retailerWebSiteLink && (
        <SC.RetailerCardWebSiteLink {...retailerWebSiteLink} href={undefined} />
      )}
      {description && (
        <SC.RetailerCardDescription>{description}</SC.RetailerCardDescription>
      )}

      {(numberOffers || minPrice || otherOffersLink) && (
        <SC.RetailerCardOtherOffersBlock>
          {otherOffersLink && (
            <>
              <SC.RetailerCardOtherOffersLink>
                <SC.RetailerCardOtherOffers>
                  {numberOffers && (
                    <SC.RetailerCardNumberOffers>
                      {numberOffers}
                    </SC.RetailerCardNumberOffers>
                  )}
                  {minPrice && (
                    <SC.RetailerCardMinPrice>
                      {minPrice}
                    </SC.RetailerCardMinPrice>
                  )}
                </SC.RetailerCardOtherOffers>
                <SC.ArrowRight icon={Icons.arrowRight} width={16} />
              </SC.RetailerCardOtherOffersLink>
            </>
          )}
        </SC.RetailerCardOtherOffersBlock>
      )}
    </SC.RetailerCard>
  )
}

export default RetailerCard
